import {Link} from 'react-router-dom';
import React/*, {useState}*/ from 'react';

import {useracc, postApi, consoleLog} from '../../../utils/functions';
import {UserContext, TestService} from '../../../utils/usercontext';
//import EventEmitter from '../../../utils/emmiter';
import VideoPlayer from '../video/video';
import Blocks from '../bbcode/blocks';
import moment from 'moment';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import '../fontawesome/fontawesome';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

import './overview.css';

export default class PortalOverview extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
    this.state = {
			service: {},
      overview: {},
		};
		this.getOverview = this.getOverview.bind(this);
    this.onError = this.onError.bind(this);
    this.isPlaying = this.isPlaying.bind(this);
    this.timeAgo = this.timeAgo.bind(this);
  };

  async componentDidMount() {
    const value = this.context;
		const getUser = await useracc();
		value.setUser( getUser );
		value.setTheme( getUser );
    await value.setWorker( this.props.service );
		this.getOverview();
	}

  async getOverview() {
    const value = this.context;
    let params = new URLSearchParams();
		params.append('service', this.props.service);
		const x = await postApi(`${value.worker[this.props.service]}/v3/service/overview`, params);
    consoleLog(x.data);
    if( x?.response?.status === 401 ) {
      window.location.href = `/`;
    }
    if( x.status === 200 ) {

      let service = this.state.service;
		  service.status = true;
		  service.name = x.data.servicename;

      this.setState({service, overview: x.data});

      /*this.setState({
        status: true,
        service: x.data.service||{},
        //invite: [],
        followers: x.data.followers||[],
        invites: x.data.invites||[],
        admins: x.data.admins||[],
        members: x.data.members||[],
        stage: x.data.stage||{},
        schedule: x.data.schedule||[],
        next: x.data.next||[],
      });*/
    }
  }


  onError(event) {
		//this.setState({stage: this.state.stage_temp});
	}


  async isPlaying(playing) {
    //this.setState({videoPlaying: playing});
  }

  timeAgo(time) {
		let date = new Date();
		const _time = Math.floor( Math.abs((Date.now()/1000+date.getTimezoneOffset() * 60) - time) / 60) ;
		let past = time < Math.floor(Date.now()/1000+date.getTimezoneOffset() * 60);
		let _return = '';
    if( _time < 1 ) return( <>Online</> );
		if( _time >= 1 ) _return = Math.floor(_time).toString() + " mins";
		if( _time >= 60 ) _return = Math.floor(_time/60).toString() + " hour" + (Math.floor(_time/60)>1?"s":"");
		if( _time >= 1440 ) _return = Math.floor(_time/1440).toString() + " day" + (Math.floor(_time/1440)>1?"s":"");
		return( <>{!past&&'In '}{_return}{past&&' ago'}</> );
	}

  render() {
    const user = this.context;

    const followers = this.state.overview.followers?.map((e, i) => {
			return (
				<Col key={i}>
					<div className="card custom-card">
						<div className="card-body">
							<div className="d-flex align-items-center">
								<div className="me-2">
									<div className="avatar avatar-md bg-success-transparent">
										<img src={`https://cloud.ultrastream.io/images/platforms/${e.platform.toLowerCase()}.png`} alt="Platform Avatar" />
									</div>
								</div>
								<div className="flex-1">
									<a aria-label="anchor" href="javascript:void(0)" className="tx-inverse float-end text-muted" data-bs-toggle="dropdown" aria-expanded="false"><i className="bi bi-three-dots tx-14"></i></a>
									<ul className="dropdown-menu">
										<li><a href="javascript:void(0)" className="dropdown-item border-bottom">Action</a></li>
										<li><a href="javascript:void(0)" className="dropdown-item border-bottom">Another Action</a></li>
										<li><a href="javascript:void(0)" className="dropdown-item">Something Else Here</a></li>
									</ul>
									<div className="mg-b-6">
										<p className="mb-0 tx-13 text-muted">{e.username} Followers</p>
									</div>
									<div className="flex-between">
										{/*<h3 className="tx-20 mb-0 font-weight-normal">{e.followers} here</h3>*/}

										<p className="text-lg fw-semibold mb-1">{e.followers}
											{e.month &&
												<OverlayTrigger
													placement="top"
													delay={{ show: 250, hide: 400 }}
													overlay={<Tooltip id="button-tooltip">
														{e.month[1]>0?'Gained':'Lost'} {Math.abs(e.month[1])} followers in the last month
													</Tooltip>}
												>
													<span>
													{e.month && e.month[0] > 0 &&
														<span className="text-success fs-12 ms-2">
															<FontAwesomeIcon icon="arrow-trend-up" className="me-2 fs-12" />
															{Math.abs(e.month[0])}%
														</span>
													}
													{e.month && e.month[0] < 0 &&
														<span className="text-danger fs-12 ms-2">
															<FontAwesomeIcon icon="arrow-trend-down" className="me-2 fs-12" />
															{Math.abs(e.month[0])}%
														</span>
													}
													</span>
												</OverlayTrigger>
											}
											
										</p>

									</div>
									<div>
										{e?.twitch_bits > 0 &&
											<>Bits {e.twitch_bits}, </>
										}
										{e?.twitch_subscribe > 0 &&
											<>Subscribers {e.twitch_subscribe}, </>
										}
										{e?.twitch_trains > 0 &&
											<>Trains {e.twitch_trains}, </>
										}
									</div>
								</div>
							</div>
						</div>
					</div>
				</Col>
			)
		});

    const admins = this.state.overview.admins?.map((e,i) => {
			return (
        <OverlayTrigger
          key={i}
          placement="right"
          delay={{ show: 250, hide: 400 }}
          overlay={<Tooltip id="button-tooltip">
            <>{e.title?e.title:e.username} {e.id_level===40?'(Owner)':'(Admin)'}</>
          </Tooltip>}
        >
          <Link to={`/profile/${e.username}`} key={i} className="avatar avatar-md" >
            <img alt="avatar" className="rounded-circle" src={`https://cloud.ultrastream.io${e.avatar}`} />
          </Link>
        </OverlayTrigger>
      )
    });

    const members = this.state.overview.members?.map((e,i) => {
			return (
        <OverlayTrigger
          key={i}
          placement="right"
          delay={{ show: 250, hide: 400 }}
          overlay={<Tooltip id="button-tooltip">
            {e.title?e.title:e.username}
          </Tooltip>}
        >
          <Link to={`/profile/${e.username}`} key={i} className="avatar avatar-md" >
            <img alt="avatar" className="rounded-circle" src={`https://cloud.ultrastream.io${e.avatar}`} />
          </Link>
        </OverlayTrigger>
      )
    });

    const schedule = this.state.overview.schedule?.filter(elem=>elem.cancelled===0).map((e,i) => {
      return (
        <li key={i} className="list-group-item px-2 py-1">
          <div className="d-flex align-items-center">
            <span className="avatar avatar-md">
              <img src={`https://cloud.ultrastream.io${e.avatar}`} alt="img" />
            </span>
            <div className="ms-3 fw-semibold">
              {e.title?e.title:e.usertitle?e.usertitle:e.username}<br />
              <span>{moment(e.start).format("h:mm A")} - {moment(e.end).format("h:mm A")}</span>
            </div>
          </div>
        </li>
      )
    });

    const online_admins = this.state.overview.admins?.map((e,i) => {
			return (
				<li key={i}>
					<Link to={`/profile/${e.username}`}>
						<div className="d-flex align-items-center">
							<div className="me-2 d-flex align-items-center">
								<span className={`avatar avatar-sm avatar-rounded ${'online'}`}>
									<img src={`https://cloud.ultrastream.io${e.avatar}`} alt="" className="rounded-circle" />
								</span>
								</div>
								<div className="flex-fill">
									<span>{e.title?e.title:e.username}</span>
								</div>
								<div>
									<span className="fs-10 fw-semibold text-muted">{this.timeAgo(e.lastconnect)}</span>
								</div>
						</div>
					</Link>
				</li>
			)
		});
		const online_members = this.state.overview.members?.map((e,i) => {
			return (
				<li key={i}>
					<Link to={`/profile/${e.username}`}>
						<div className="d-flex align-items-center">
							<div className="me-2 d-flex align-items-center">
								<span className={`avatar avatar-sm avatar-rounded ${'online'}`}>
									<img src={`https://cloud.ultrastream.io${e.avatar}`} alt="" className="rounded-circle" />
								</span>
								</div>
								<div className="flex-fill">
									<span>{e.title?e.title:e.username}</span>
								</div>
								<div>
									<span className="fs-10 fw-semibold text-muted">{this.timeAgo(e.lastconnect)}</span>
								</div>
						</div>
					</Link>
				</li>
			)
		});

		return (
			<>
        {this.state.service.status === true &&
          <>
            {this.props.version === 'full' &&
              <Col sm={12}>
                {this.state.overview.followers.length > 0 ?
                  <Row>{followers}</Row>
                :
                  <div className="card custom-card">
                    <div className="d-flex p-3 border-bottom-0">
                      <div className="">
                        <svg className="me-4 bg-success-transparent  alt-notify" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="#75cfa5" d="m20.34 9.32-13.99-7a3 3 0 0 0-4.08 3.9L4.41 11l.26.59a1.06 1.06 0 0 1 0 .82l-.26.59-2.14 4.78a2.954 2.954 0 0 0 .67 3.38A2.966 2.966 0 0 0 5 22a3.141 3.141 0 0 0 1.35-.32l13.99-7a2.993 2.993 0 0 0 0-5.36Z"></path><path fill="#198754" d="M14.46 12a.997.997 0 0 1-1 1H4.41l.26-.59a1.06 1.06 0 0 0 0-.82L4.41 11h9.05a.997.997 0 0 1 1 1Z"></path></svg>
                      </div>
                      <div className="mt-0 text-start">
                        <span className="fs-14 fw-semibold">{this.state.service.name}</span>
                        <p className="fs-13 text-muted mb-0">An overview and outlook of your {this.state.service?.title}.</p>
                      </div>
                    </div>
                    <TestService service={this.state.service.id} worker={user.worker[this.state.service.id]} />
                  </div>
                }
              </Col>
            }
            <Col md={this.props.version === 'full'?9:6} sm={12}>
              <div className="card custom-card ">
                <div className="card-header p-0 card-service">
                  <div className="d-flex card-service-header align-items-center service-border-bottom" style={{backgroundColor: `${this.state.overview.embed_color}20`}}>
                    <img src={`https://cloud.ultrastream.io/images/${this.state.overview.avatar}`} alt="Avatar" />
                    <span className="product-name fs-14 fw-semibold ms-3">{this.state.overview.title}</span>
                  </div>
                </div>
                <div className="card-body p-0">
                  <Row className="gx-0 p-0 m-0 service-border-bottom">

                    <Col md={5} className="service-livestream">
                      <Link to={`/${this.state.service.id}/live`}>
                        {Object.keys(this.state.overview.stage).length === 0 ?
                          <img src={`https://cloud.ultrastream.io/images/components/offline.jpg`} alt="Avatar" />
                        :
                          <VideoPlayer
                            id="video"
                            service={this.props.service} //{this.state.select.address}
                            //select={this.state.select_temp.select}
                            autoPlay={true}
                            uid={user.user.user.id}
                            theatre={this.theatre}
                            onError={this.onError}
                            height={this.state.meta?.video?.height}
                            isPlaying={this.isPlaying}
                          />
                        }
                      </Link>
                    </Col>
                    <Col md={7}>
                      <div className="flex-1 p-2">
                        <p className="tx-capitalize mb-1 fs-14 fw-semibiold"><b>
                          {Object.keys(this.state.overview.stage).length === 0 ?
                            <>Stream Offline</>
                          :
                            <>{this.state.overview.stage.title?this.state.overview.stage.title:this.state.overview.stage.username}</>
                          }
                        </b></p>
                        {this.state.overview.admins.length > 0 &&
                          <>
                            <p className="tx-capitalize mb-1 fs-14 fw-semibiold">Admins {this.state.overview.adminsMax}</p>
                            <div className="d-flex">
                              <div className="avatar-list-stacked">
                                {admins}
                              </div>
                            </div>
                          </>
                        }
                        {this.state.overview.members.length > 0 &&
                          <>
                            <p className="tx-capitalize mb-1 fs-14 fw-semibiold">Members {this.state.overview.membersMax}</p>
                            <div className="d-flex">
                              <div className="avatar-list-stacked">
                                {members}
                              </div>
                            </div>
                          </>
                        }
                      </div>
                    </Col>
                  </Row>

                  {this.state.overview.schedule.length > 0 &&
                    <ul className="list-group service-border-bottom" style={{borderRadius: 0}}>
                      <li className="list-group-item px-2 py-1">
                        <div className="d-flex align-items-center">
                          <span className="avatar avatar-md">
                            <img src={`https://cloud.ultrastream.io/images/${this.state.overview.avatar}`} alt="img" />
                          </span>
                          <div className="ms-3 fw-semibold">
                            {this.state.service.showname}
                          </div>
                        </div>
                      </li>
                      {this.state.overview.schedule.length === 0 &&
                        <li className="list-group-item">
                          <div className="d-flex align-items-center">
                            <div className="ms-3 fw-semibold text-muted">
                              No schedule bookings, <Link to={`/${this.props.service}/schedule`}>View Schedule</Link>
                            </div>
                          </div>
                        </li>
                      }
                      {schedule}
                    </ul>
                  }

                  {this.state.service.description &&
                    <div className="product-description fs-13 mb-0 p-3">
                      <Blocks id={`editor-${this.state.service.id}`} blocks={this.state.service.description} />
                    </div>
                  }
                  
                  {/*<p className="badge bg-secondary-transparent fs-11 rounded-1 mb-0">72% off</p>
                  <span className="badge bg-warning-transparent rounded-1">4.2 <i className="ri-star-s-fill align-middle  d-inline-block"></i> </span>
                  <span className="text-muted">(12,456)</span>
                  <p className="fs-11 text-success fw-semibold mb-0 align-items-center"> Free Delivery </p>
                  <div className="mt-2">
                    <a href="wishlist.html" className="btn btn-sm btn-danger-light me-1"><i className="ri-heart-line"></i></a>
                    <a href="cart.html" className="btn btn-sm btn-info-light me-1"><i className="ri-shopping-cart-line"></i></a>
                    <a href="product-details.html" className="btn btn-sm btn-success-light"><i className="ri-eye-line"></i></a>
                  </div>*/}
                    
                </div> 
              </div>
            </Col>
            {this.props.version === 'full' && (this.state.overview.admins.length > 0 || this.state.overview.members.length > 0 ) &&
              <Col lg={3}>
                <div className="team-groups">
                  <div className="card custom-card">
                    <div className="card-header d-flex align-items-center justify-content-between">
                      <h6 className="fw-semibold mb-0">Radio Team</h6>
                    </div>
                    <div className="card-body p-0">
                      <div className="teams-nav" id="teams-nav" data-simplebar="init">
                        <div className="simplebar-wrapper" style={{margin: 0}}>
                          <div className="simplebar-height-auto-observer-wrapper">
                              <div className="simplebar-height-auto-observer"></div>
                          </div>
                          
                              <div className="simplebar-content-wrapper" tabIndex="0" role="region" aria-label="scrollable content" >
                                <div className="simplebar-content" style={{padding: 0}}>
                                  <ul className="list-unstyled mb-0 mt-2">
                                    <li className="pb-0">
                                      <div className="d-flex justify-content-between align-items-center">
                                        <div className="fs-10 fw-semibold mb-2 text-muted">OWNER / ADMINS</div>
                                      </div>
                                    </li>
                                    {online_admins}
                                    <li className="pb-0">
                                      <div className="d-flex justify-content-between align-items-center">
                                        <div className="fs-10 fw-semibold mb-2 text-muted">DJ TEAM (Latest Online)</div>
                                      </div>
                                    </li>
                                    {online_members}
                                  </ul>
                                </div>
                              </div>
                            
                          {/*<div className="simplebar-placeholder" style={{width: 'auto', height: 890}}></div>*/}
                        </div>
                        <div className="simplebar-track simplebar-horizontal" style={{visibility: 'hidden'}}>
                          <div className="simplebar-scrollbar" style={{width: 0, display: 'none'}}></div>
                        </div>
                        <div className="simplebar-track simplebar-vertical" style={{visibility: 'hidden'}}>
                          <div className="simplebar-scrollbar" style={{height: 728, transform: 'translate3d(0px, 0px, 0px)', display: 'block'}}></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
            }
          </>
        }
      </>
    )
  }
}


